import { makeStyles } from '@material-ui/core/styles';
import {ItemTick} from "../../../assets/images/images";
export const useStyles = makeStyles((theme) => ({
    projectlist: {
      "& li": {
        position: "relative",
    },
      "& li:before": {
        position: "absolute",
        left: "0px",
        top: "2px",
        content: "''",
        backgroundImage: `url("${ItemTick}")`,
        backgroundRepeat: "no-repeat",
        backgroundPosition: "0px 0px",
        width: "24px",
        height: "24px",
        [theme.breakpoints.down('sm')]: {
          top: "0px",
              },
    }
        
      }
}));    
